import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { ProjectPermissionType } from "entities/projects/types/ProjectPermissions"

import { useProductPositionFormCoreContext } from "../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormFeaturesContext } from "../contexts/ProductPositionFormFeaturesContext"

export const ProductPositionConfigurationButtons = React.memo(() => {
  const { t } = useTranslation()
  const { isReadonly, formOptions, permissions } =
    useProductPositionFormCoreContext()
  const {
    isConfigurationDisabled,
    openPortfolio,
    openProductConfiguration,
    openProductDimensioning
  } = useProductPositionFormFeaturesContext()
  const {
    hideOpenProductConfigurationLink,
    hideOpenProductConfigurationLinkWhileEditing
  } = formOptions || {}

  const canChangeConfiguration =
    permissions[ProjectPermissionType.EDIT] &&
    !hideOpenProductConfigurationLink &&
    (isReadonly || !hideOpenProductConfigurationLinkWhileEditing)

  const showPortfolioButton = openPortfolio && canChangeConfiguration
  const showConfigurationButton =
    (openProductConfiguration || openProductDimensioning) &&
    canChangeConfiguration
  const showDimensioningButton =
    (openProductDimensioning || openProductConfiguration) &&
    canChangeConfiguration

  return (
    <div className="product-position-form__configuration-buttons button-group">
      {showConfigurationButton ? (
        <Button
          data-testid="product-configuration-button"
          variant={ButtonVariant.PRIMARY}
          disabled={isConfigurationDisabled || !openProductConfiguration}
          onClick={openProductConfiguration}
          icon={IconName.CONFIGURATION}
        >
          {t("Product.Configuration.Configure")}
        </Button>
      ) : null}
      {showDimensioningButton ? (
        <Button
          data-testid="product-dimensioning-button"
          variant={ButtonVariant.PRIMARY}
          disabled={isConfigurationDisabled || !openProductDimensioning}
          onClick={openProductDimensioning}
          icon={IconName.DIMENSIONING}
        >
          {t("Product.Configuration.Dimension")}
        </Button>
      ) : null}
      {showPortfolioButton ? (
        <Button
          data-testid="open-portfolio-button"
          variant={ButtonVariant.PRIMARY}
          className="w-100"
          onClick={openPortfolio}
          icon={IconName.PRODUCTS}
        >
          {t("Product.Configuration.ChooseProduct")}
        </Button>
      ) : null}
    </div>
  )
})
